import logoImg from '../assets/images/logo/logo.png';
import Comp_Popup_Contact from '../component_version2/comp_popup_contact';
import './footer.css';
export const Footer=()=>{

    return(
        <div>
            {/* <Comp_Popup_Contact/> */}
        <div className="footer-area">
        <div className="footer-container">
            <div className="footer-top">
                <div className="container">
                    <div className="row">
                        
                        <div className="col-md-6 col-lg-4 mb-md-30px mb-lm-30px">
                            <div className="single-wedge">
                            <img style={{"background":"#fff"}} src={logoImg} class="company-logo"/>
                            <p>Digital Seva Point</p>
                            <p>Contact Us: <a class="white" href='tel:7999612682'>7999612682</a>, 
                             <a class="white" href='tel:7987033463'>  7987033463</a>,
                             <a class="white" href='tel:7697642751'>  7697642751</a>
                            </p>
                            <ul className="link-follow">
                               
                               <li className="li">
                                   <a className="icon-social-facebook" target={"blank"} title="Facebook" href="https://www.facebook.com/share/1CWakpXKVa/"></a>
                               </li>
                               {/* <li className="li">
                                   <a className="ion-social-linkedin-outline" target={"blank"} title="Linkedin" href="https://www.linkedin.com/in/mansha-mishra-3954a2281/"></a>
                               </li>
                               <li className="li">
                                   <a className="icon-social-youtube" target={"blank"} title="Youtube"  href="https://www.youtube.com/@AstroMansha"></a>
                               </li> */}
                               
                               <li className="li">
                                   <a className="icon-social-instagram" target={"blank"}  title="Instagram" href="https://www.instagram.com/digitalsevapoint026/"></a>
                               </li>
                               {/* <li className="li">
                                   <a className="linkedin icon-social-linkedin" title="Linkedin" href="#"></a>
                               </li> */}
                           </ul>
                            </div>
                        </div>
                       
                        <div className="col-md-6 col-sm-6 pl-10 col-lg-3 mb-md-30px mb-lm-30px">
                            <div className="single-wedge">
                                <h4 className="footer-herading">Information</h4>
                                <div className="footer-links">
                                    <div className="footer-row">
                                        <ul className="align-items-center">
                                            <li className="li"><a className="single-link" href="../home">Home</a></li>
                                            <li className="li"><a className="single-link" href="../about_us">About Us</a></li>
                                            <li className="li"><a className="single-link" href="../blogs">Blogs</a></li>
                                          
                                            <li className="li"><a className="single-link" href="../contact_us">Contact Us</a></li>
                                            
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-md-6 col-lg-3 col-sm-6 mb-lm-30px">
                            <div className="single-wedge">
                                <h4 className="footer-herading">Quick Links</h4>
                                <div className="footer-links">
                                    <div className="footer-row">
                                        <ul className="align-items-center">
                                        <li className="li"><a className="single-link" href="../privacy_policy">Privacy Policy</a></li>
                                            <li className="li"><a className="single-link" href="../terms_conditions">Terms & Condition</a></li>
                                            <li className="li"><a className="single-link" href="../Return_Cancellation_Policy">Return & Cancellation Policy</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                       
                        <div className="col-md-6 col-lg-2">
                            <div className="single-wedge">
                                <h4 className="footer-herading">newsletter</h4>
                                <div className="footer-links">
                                    
                                    <div id="mc_embed_signup" className="subscribe-form">
                                        <form id="mc-embedded-subscribe-form" className="validate" novalidate="" target="_blank" name="mc-embedded-subscribe-form">
                                            <div id="mc_embed_signup_scroll" className="mc-form">
                                                <input className="email" type="email" required="" placeholder="Your Mail*" name="EMAIL" value="" />
                                                <div className="mc-news" aria-hidden="true">
                                                    <input type="text" value="" tabindex="-1" name="b_6bbb9b6f5827bd842d9640c82_05d85f18ef" />
                                                </div>
                                                <div className="clear">
                                                    <button id="mc-embedded-subscribe" className="button btn-primary" type="submit" name="subscribe" value=""><i
                                                            className="icon-cursor"></i> Send Mail</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="container">
                    <div className="row flex-sm-row-reverse">
                        {/* <div className="col-md-6 text-right">
                            <div className="payment-link">
                                <img src="assets/images/icons/payment.png" alt="" />
                            </div>
                        </div> */}
                        <div className="col-md-12 text-left">
                            <p className="copy-text">© Copyright 2025 <strong>Digital Seva Point</strong> <a className="company-name" href="javascript:void(0)">
                                {/* <strong>ashtechnologies.in</strong> */}
                                </a>.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        {/* <Cart_Canvas/> */}
        <div className="offcanvas-overlay"></div>
        </div>)
}
export default Footer;